import React, { useContext } from 'react'
import './about.css';
import { UserContext } from '../../App';
import photo_1 from '../../assets/about/About-1.png';
import photo_2 from '../../assets/about/About-2.png';
import photo_3 from '../../assets/about/About-3.jpg';
import { Link } from 'react-router-dom';


function Aboutt() {
    const {theme,setTheme}=useContext(UserContext);
  return (

      <section className="timeline" id={theme==0?'bg-light':'bg-dark'} style={{paddingTop:"8rem",marginBottom:"0px"}}>
        <center> <h2 id={theme==0?"type-light":"type-dark"}>About</h2></center>
        <div className={theme==0?'para-light':'para-dark'}>
        <img  id="pic" src={photo_3} alt="pic-3" />
        <p>I'm Murali Krishna from Vijayawada, 22 years old. I graduated with a degree in Electronics and Communication Engineering from Amrita Sai Institute of Science and Technology.After graduation, I began freelancing with Chegg india pvt.ltd, its a U.S.-based platform,my role was Chegg expert in Computer Science that means i providing coding solutions to students that allowed me to delve into web technologies such as JavaScript, Python, HTML, and CSS.
            . I further specialized as a UI Full Stack Web Developer at Naresh I Technologies in Hyderabad. During this course, I completed an impactful internship, working on projects including a robust e-commerce women’s store, a live chat application, and an employee management system. These projects sharpened my skills and helped me master various frontend and backend technologies like React, MongoDB, Express, and Node.js.
</p>
        
        </div>

        <div className={theme==0?'para-light':'para-dark'}>
        
        <p >
            after,I had been exploring more technologies under the guidance of Codtech IT Solutions Pvt. Ltd. in Hyderabad, where I'm exploring new technologies such as React Native, Flutter, and Figma. This experience is enhancing my skills and keeping me updated with industry trends.</p>
           
            <img  id="pic" src={photo_2} alt="pic=2" />
        </div>
        <div className={theme==0?'para-light':'para-dark'}>
        
        <p>I invite you to review my portfolio and recent projects on my GitHub and LinkedIn profiles. I'm enthusiastic about the opportunity to contribute to a reputed company and look forward to the possibility of joining your team.
            Please feel free to reach out with any questions or to discuss how I can contribute to your projects. Thank you for considering my application. I look forward to the opportunity to work together.

            Best regards, Murali Krishna</p>
            <img id="pic" src={photo_1} alt="pic-1" />
            
        </div>
            



        
        <div className="title-wrapper">
        <div className="icon-box">
            <ion-icon name="book-outline"></ion-icon>
        </div>


        <h3 className="h3" id={theme==0?"type-light":"type-dark"}>Education</h3>
        </div>

        <ol className={theme==0?"timeline-list-light":"timeline-list-dark"}>

        <li className={theme==0?"timeline-item-light":'timeline-item-dark'}>

            <h4 className="h4 timeline-item-title">AMRITA SAI INSTITUTION OF 
            SCIENCE AND TECHNOLOGY ( BTECH - JNTUK )</h4>

            <span>2019 — 2023<h5>73.5 CGPA</h5></span>

        </li>

        <li className={theme==0?"timeline-item-light":'timeline-item-dark'}>

            <h4 className="h4 timeline-item-title">TEJA DVR JUNIOR COLLEGE ( INTERMEDIATE - BIEAP )</h4>

            <span>2019 — 2017<h5>78.8 CGPA</h5></span>

        </li>

        <li className={theme==0?"timeline-item-light":'timeline-item-dark'}>

            <h4 className="h4 timeline-item-title">ZP HIGH SCHOOL ( BSEAP )</h4>

            <span>Year of Pass - 2017<h5>78 CGPA</h5></span>



        </li>

        </ol>
        <div className='ExploreResume'>
            <button className={theme==0?'btn-light':'btn-dark'} ><Link id="link"  to="/resume">Explore Resume</Link></button>
        </div>
        </section>
        
  )
}

export default Aboutt
